import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_branded_fares_loading_sr",
    defaultStage: 1,
    stages: {
        sr_users_with_requestable_bf: 1,
        users_click_on_expanded_bf_button: 2,
        users_with_false_positive_no_bf: 3,
        users_sees_loader: 4,
        desktop: 5,
        mdot: 6,
        delta_pre_expanded: 7,
        firefly_pre_expanded: 8
    },
    goals: {
        user_click_fare_sr: 1,
        user_sees_loader: 2,
        users_sees_one_bf_only: 3
    },
    goalsWithValue: []
});
const trackStages = (props) => {
    utils.stages.sr_users_with_requestable_bf();
    if (props.isMobile) {
        utils.stages.mdot();
    }
    if (!props.isMobile) {
        utils.stages.desktop();
    }
};
const trackPreExpanded = (props) => {
    if (props.isDelta && props.isPreExpanded) {
        utils.stages.delta_pre_expanded();
    }
    if (props.isFirefly && props.isPreExpanded) {
        utils.stages.firefly_pre_expanded();
    }
};
const trackButtonClick = (props) => {
    utils.stages.users_click_on_expanded_bf_button();
    if (props.isBrandedFaresEmpty) {
        utils.stages.users_with_false_positive_no_bf();
    }
    if (!props.showFareSelector && props.brandedFareOffersCount === 1) {
        utils.goals.users_sees_one_bf_only();
    }
};
const trackFareCardClick = () => {
    utils.goals.user_click_fare_sr();
};
export default { ...utils, trackStages, trackPreExpanded, trackButtonClick, trackFareCardClick };
